import DocumentsUpload from './DocumentsUpload'
export default DocumentsUpload
